import { useState } from "react"
import "./news.css"
import NewsCard from "./NewsCard"


import apilaunch_blog from "../../assets/images/blog/test-blog.jpeg"
import bump1launch_blog from "../../assets/images/blog/blog-bump-1.jpg";
import ytlocalsupport_blog from "../../assets/images/blog/blog-localYTsupport-asset.jpg"
import zapiersupport_blog from "../../assets/images/blog/blog-zapierSupport-asset.jpg"



const News = () => {
  const [searchQuery, setSearchQuery] = useState("")

  const news = [
    {
      img: zapiersupport_blog,
      type: "Integrations",
      title: "Meet Bumpups on Zapier",
      date: "May 1, 2025",
    },
    {
      img: bump1launch_blog,
      type: "Announcements",
      title: "Introducing Bump-1.0 Model",
      date: "April 19, 2025",
    },
    {
      img: apilaunch_blog,
      type: "Product",
      title:
        "API Documentation Now Live",
      date: "April 21, 2025",
    },
    {
      img: ytlocalsupport_blog,
      type: "Product",
      title: "Local and YouTube Video Handling Supported",
      date: "November 25, 2024",
    },
  ]

  const filteredNews = news.filter((item) =>
    item.title.toLowerCase().includes(searchQuery.toLowerCase())
  )

  const handleSearch = (e) => {
    setSearchQuery(e.target.value)
  }

  return (
    <div className="news-main-container">
      <h1>News</h1>

      <input
        className="news-input-box"
        placeholder="Search"
        value={searchQuery}
        onChange={handleSearch}
      />

      <div className="news-news-container">
        {filteredNews.length > 0 ? (
          filteredNews.map((news, index) => (
            <NewsCard
              key={index}
              img={news.img}
              type={news.type}
              title={news.title}
              date={news.date}
            />
          ))
        ) : (
          <div className="news-no-results">
            <p>No results found.</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default News
